/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./edit-resource.vue?vue&type=template&id=410175ed&scoped=true&"
import script from "./edit-resource.vue?vue&type=script&lang=js&"
export * from "./edit-resource.vue?vue&type=script&lang=js&"
import style0 from "./edit-resource.vue?vue&type=style&index=0&id=410175ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410175ed",
  null
  
)

export default component.exports